import { api } from "./api";
import {
  IRequestNumberResponse,
  TSendCouponRequest,
  TSupportMessage,
  TSupportRequest,
  TSupportTicketResponse,
  TUploadResponse,
} from "../types/requests.types";

export const requestsApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendCoupon: build.mutation<IRequestNumberResponse, TSendCouponRequest>({
      query: ({ coupon, id }) => ({
        url: `/coupon/${id}`,
        method: "POST",
        coupon,
      }),
    }),
    sendTechSupportRequest: build.mutation<
      IRequestNumberResponse,
      TSupportRequest
    >({
      query: ({ request }) => ({
        url: `support`,
        method: "POST",
        body: request,
        request,
      }),
    }),
    postSupportMessage: build.mutation<
      TSupportTicketResponse,
      Partial<TSupportMessage>
    >({
      query: (body) => ({
        url: `Admintech/Supports/CreateTicket`,
        method: "POST",
        body,
      }),
    }),
    //2 support file, 3 audio file for ai
    postFile: build.mutation<
      TUploadResponse,
      {
        file: File;
        ticketId: string | number;
        type?: number;
      }
    >({
      query: ({ file, ticketId, type = 2 }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `files/UploadFiles/${type}/${ticketId}`,
          method: "POST",
          body: formData,
        };
      },
    }),
    sendCustomerServiceRequest: build.mutation<
      IRequestNumberResponse,
      TSupportRequest
    >({
      query: ({ request }) => ({
        url: `customerService`,
        method: "POST",
        body: request,
        request,
      }),
    }),
  }),
});

export const {
  useSendCouponMutation,
  useSendTechSupportRequestMutation,
  useSendCustomerServiceRequestMutation,
  usePostSupportMessageMutation,
  usePostFileMutation,
} = requestsApi;
